module.exports = "/_next/static/images/img_advisor-3ee4066d951a10b6a55654f10d101cf6.svg";